var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.shouldShowPicker,
                      expression: "!shouldShowPicker",
                    },
                  ],
                  on: { click: _vm.chooseOperator },
                },
                [_vm._v(_vm._s(_vm.buttonLabel))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectedOperator,
                      expression: "selectedOperator",
                    },
                  ],
                  on: { click: _vm.clearOperator },
                },
                [_vm._v("Clear")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.shouldShowPicker
            ? _c(
                "v-col",
                { attrs: { cols: "10" } },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-col", { attrs: { cols: "2" } }, [
                            _vm._v("Travel Operator: "),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { attrs: { cols: "10" } },
                            [
                              _c("v-text-field", {
                                attrs: { "hide-details": "" },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateOperatorName()
                                  },
                                },
                                model: {
                                  value: _vm.operatorViewName,
                                  callback: function ($$v) {
                                    _vm.operatorViewName = $$v
                                  },
                                  expression: "operatorViewName",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.operatorOptions.length
                            ? _c("v-col", { attrs: { cols: "12" } }, [
                                _c(
                                  "ul",
                                  _vm._l(
                                    _vm.operatorOptions,
                                    function (operator) {
                                      return _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectOperator(
                                                operator.user_key
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(operator.username) +
                                              ") " +
                                              _vm._s(operator.first_name) +
                                              " " +
                                              _vm._s(operator.surname)
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-btn", { on: { click: _vm.done } }, [
                                _vm._v("Done"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: _vm.field.fieldName },
            domProps: { value: _vm.field.value },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }